import { autoinject } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BaseModal } from "../../../../models/basics/basics.models";
import { LookupHierarchyControl } from "./lookup-hierarchy-control";

@autoinject
@transient()
export class LookupHierarchyControlModal extends BaseModal {

    public model: LookupHierarchyControl;
    public selectedLookupValues = [{}];

    constructor(dialogService: DialogClientService) {
        super(dialogService);
    }

    activate(model: LookupHierarchyControl): void {
        this.model = model;
        if (model && model.itemSource) {
            const list = this.getIndex(0, model.itemSourceFiltered);

            if (list) {
                for (let i = 0; i < list.length; i++) {
                    this.setSelectedItem(i,
                        {
                            detail: {
                                value: list[i]
                            }
                        });
                }
            }

        }
    }

    removeFromIndex(index: number) {
        const length = this.selectedLookupValues.length;
        if(index == length - 1 && length > 1){
            return;
        }
        this.selectedLookupValues.splice(index, length - index);
    }

    ok() {
        this.model.selectedItem = this.model.selectedItemInternal;
        this.model.selectedValue = this.model.getValue(this.model.selectedItem);
        this.hideModal();
    }

    clear() {
        this.model.selectedItem = null;
        this.model.selectedValue = null;
        this.hideModal();
    }
    
    private getIndex(index: number, items: any[]): any[] {

        for (const x of items) {
            if (this.model.selectedItem && x.id === this.model.selectedItem.id) {
                return [x];
            } else {
                const list = this.getIndex(index + 1, x.children);
                if (list) {
                    list.splice(0, 0, x);
                    return list;
                }
            }
        }

        return null;
    }


    public setSelectedItem(index: number, event: any): void {
        if (event) {
            if (this.selectedLookupValues.length - 1 >= index) {
                this.selectedLookupValues.splice(index, this.selectedLookupValues.length - index, event.detail.value);
            } else if (this.selectedLookupValues.length === index) {
                this.selectedLookupValues.push(event.detail.value);
            }
        }
    }
}
